export interface GameItem {
  id: string;
  title: string;
  slug: string;
  category: string;
  imageSeq: string;
  rating: number;
  downloads: string;
  size: string;
  platform: string;
  description: string;
  tags: string[];
  releaseDate: string;
  featured: boolean;
}

export const games: GameItem[] = [
  {
    id: 'g1',
    title: '暗影传说：永恒之夜',
    slug: 'shadow-legend-eternal-night',
    category: 'rpg',
    imageSeq: 'game-shadow-legend',
    rating: 9.2,
    downloads: '128,000+',
    size: '4.2 GB',
    platform: 'PC',
    description: '史诗级暗黑奇幻RPG成人游戏，宏大的世界观与深度角色养成系统，超过100小时的精彩剧情等你探索。',
    tags: ['RPG', '暗黑奇幻', '剧情丰富', '角色养成'],
    releaseDate: '2025-06-15',
    featured: true,
  },
  {
    id: 'g2',
    title: '樱花之约：校园恋曲',
    slug: 'sakura-promise-campus-love',
    category: 'visual-novel',
    imageSeq: 'game-sakura-promise',
    rating: 9.5,
    downloads: '256,000+',
    size: '2.8 GB',
    platform: 'PC',
    description: '超高人气校园恋爱视觉小说，精美的日系CG画面与动人的音乐，六位女主角的多线剧情任你选择。',
    tags: ['视觉小说', '校园恋爱', '多线剧情', '日系画风'],
    releaseDate: '2025-08-01',
    featured: true,
  },
  {
    id: 'g3',
    title: '王国纷争：征服之路',
    slug: 'kingdom-warfare-conquest',
    category: 'simulation',
    imageSeq: 'game-kingdom-warfare',
    rating: 8.8,
    downloads: '89,000+',
    size: '3.5 GB',
    platform: 'PC',
    description: '策略经营与成人元素的完美结合，建立你的王国，招募英雄，征服大陆。真实的经济与外交系统。',
    tags: ['模拟经营', '策略', '王国建设', '英雄招募'],
    releaseDate: '2025-05-20',
    featured: true,
  },
  {
    id: 'g4',
    title: '深渊猎人：血月降临',
    slug: 'abyss-hunter-blood-moon',
    category: 'action',
    imageSeq: 'game-abyss-hunter',
    rating: 8.9,
    downloads: '156,000+',
    size: '5.1 GB',
    platform: 'PC',
    description: '硬核动作冒险成人游戏，流畅的战斗系统与震撼的BOSS战，探索被诅咒的深渊世界。',
    tags: ['动作冒险', '硬核战斗', 'BOSS战', '暗黑风格'],
    releaseDate: '2025-07-10',
    featured: false,
  },
  {
    id: 'g5',
    title: '密室逃脱：欲望迷宫',
    slug: 'escape-room-desire-maze',
    category: 'puzzle',
    imageSeq: 'game-escape-room',
    rating: 8.6,
    downloads: '72,000+',
    size: '1.6 GB',
    platform: 'PC / Mobile',
    description: '烧脑的密室逃脱解谜游戏，每个关卡都暗藏玄机，解开谜题揭开隐藏在背后的秘密。',
    tags: ['解谜', '密室逃脱', '烧脑', '剧情解密'],
    releaseDate: '2025-04-28',
    featured: false,
  },
  {
    id: 'g6',
    title: '手机女友：虚拟恋爱',
    slug: 'mobile-girlfriend-virtual-love',
    category: 'mobile',
    imageSeq: 'game-mobile-girlfriend',
    rating: 9.0,
    downloads: '512,000+',
    size: '890 MB',
    platform: 'Mobile',
    description: '最受欢迎的移动端恋爱模拟游戏，真实模拟恋爱互动体验，支持安卓和iOS双平台畅玩。',
    tags: ['手机游戏', '恋爱模拟', '双平台', '互动体验'],
    releaseDate: '2025-09-01',
    featured: true,
  },
  {
    id: 'g7',
    title: '龙脉觉醒：上古传说',
    slug: 'dragon-vein-awakening',
    category: 'rpg',
    imageSeq: 'game-dragon-vein',
    rating: 9.1,
    downloads: '198,000+',
    size: '4.8 GB',
    platform: 'PC',
    description: '东方玄幻题材开放世界RPG成人游戏，自由探索广阔的仙侠世界，修炼功法，结交伙伴。',
    tags: ['RPG', '东方玄幻', '开放世界', '仙侠'],
    releaseDate: '2025-06-30',
    featured: false,
  },
  {
    id: 'g8',
    title: '星光舞台：偶像之路',
    slug: 'starlight-stage-idol-road',
    category: 'simulation',
    imageSeq: 'game-starlight-stage',
    rating: 8.7,
    downloads: '95,000+',
    size: '3.0 GB',
    platform: 'PC',
    description: '偶像养成模拟成人游戏，从练习生到顶流巨星的完整成长路线，打造属于你的娱乐帝国。',
    tags: ['模拟经营', '偶像养成', '娱乐圈', '成长路线'],
    releaseDate: '2025-05-12',
    featured: false,
  },
  {
    id: 'g9',
    title: '迷幻都市：霓虹之夜',
    slug: 'neon-city-cyber-mystery',
    category: 'visual-novel',
    imageSeq: 'game-neon-city',
    rating: 9.3,
    downloads: '178,000+',
    size: '3.2 GB',
    platform: 'PC',
    description: '赛博朋克风格的悬疑视觉小说，在霓虹灯闪烁的未来都市中，揭开惊天阴谋。电影级叙事体验。',
    tags: ['视觉小说', '赛博朋克', '悬疑', '科幻'],
    releaseDate: '2025-08-15',
    featured: true,
  },
  {
    id: 'g10',
    title: '遗迹探险：秘境寻踪',
    slug: 'relic-explorer-mystic-quest',
    category: 'action',
    imageSeq: 'game-relic-explorer',
    rating: 8.5,
    downloads: '67,000+',
    size: '2.9 GB',
    platform: 'PC',
    description: '古墓探险动作成人游戏，穿越神秘遗迹，破解古老机关，发现隐藏千年的宝藏与秘密。',
    tags: ['动作冒险', '古墓探险', '机关解谜', '探索'],
    releaseDate: '2025-03-18',
    featured: false,
  },
  {
    id: 'g11',
    title: '命运之轮：时空回响',
    slug: 'wheel-of-fate-time-echo',
    category: 'rpg',
    imageSeq: 'game-wheel-fate',
    rating: 9.0,
    downloads: '145,000+',
    size: '4.5 GB',
    platform: 'PC',
    description: '穿越时空的RPG成人游戏巨作，改写历史的关键时刻，每个选择都将影响世界的命运。',
    tags: ['RPG', '时空穿越', '蝴蝶效应', '多结局'],
    releaseDate: '2025-07-25',
    featured: false,
  },
  {
    id: 'g12',
    title: '甜蜜烘焙：恋爱厨房',
    slug: 'sweet-bakery-love-kitchen',
    category: 'mobile',
    imageSeq: 'game-sweet-bakery',
    rating: 8.8,
    downloads: '289,000+',
    size: '750 MB',
    platform: 'Mobile',
    description: '轻松治愈的手机恋爱模拟游戏，经营甜品店的同时邂逅甜蜜爱情，画风可爱，玩法轻松。',
    tags: ['手机游戏', '恋爱模拟', '经营', '治愈系'],
    releaseDate: '2025-08-22',
    featured: false,
  },
];